const { updateAvatar } = require('./avatar-generator-db')

function generateImage(detail, htmlFc) {
  if(!detail) return
  updateAvatar(detail, htmlFc);
  
}

module.exports= {
  generateImage,
}